var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcUsers = function SvgIcUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.166 16.5v-1.666a3.333 3.333 0 0 0-3.333-3.334H4.166a3.333 3.333 0 0 0-3.333 3.334V16.5m18.333 0v-1.666a3.333 3.333 0 0 0-2.5-3.226m-3.333-10a3.334 3.334 0 0 1 0 6.459m-2.5-3.234a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0Z"
  })));
};
export default SvgIcUsers;